export default __webpack_public_path__ + "static/media/connection_phone__bill.a2e6894b.svg";